<!-- src/app/app.component.html -->
<app-loading-spinner></app-loading-spinner>
<router-outlet></router-outlet>
